module.exports = __webpack_public_path__ + "static/media/16UNODC3.c4d3ec6e.jpg";